import { TFunction } from "i18next";

/**
 * Display label for a stored job denial reason ({ key, name, text? }).
 * The free text (entered for the "Annat"/OTHER option) wins over the
 * snapshotted reason name. Returns undefined when there is nothing to show.
 */
export function denialReasonLabel(reason?: { name?: string; text?: string }): string | undefined {
	return reason?.text?.trim() || reason?.name?.trim() || undefined;
}

/**
 * Hint under the job's Fakturareferens input. A job without its own
 * reference falls back to the customer's (invoiceDetails.reference) on the
 * invoice, so the customer's current value is shown when known.
 */
export function invoiceReferenceHint(t: TFunction, customerReference?: string): string {
	const reference = customerReference?.trim();
	return reference
		? t("job.invoiceReferenceHintWithCustomer", { reference })
		: t("job.invoiceReferenceHint");
}
